import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button, FormFeedback } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from 'axios';

import Footer from "../ComponentPrimer/Footer";

const schools = [
  "SMAN 4 Padang",
  "SMAN 14 Padang",
  "SMAS Adabiah 1",
  "SMAS Kartika 1-5",
  "SMAS Pertiwi 1",
  "SMKN 4 Padang",
];

const grades = ["Kelas 1", "Kelas 2", "Kelas 3"];
const majors = ["IPA", "IPS", "Bahasa", "Kejuruan", "Yang lain"];
const informationSources = [
  "Media Sosial",
  "Guru Sekolah",
  "Teman",
  "Keluarga",
  "Brosur/Poster",
  "Website",
  "Yang lain",
];
const interests = [
  "Program studi yang ditawarkan",
  "Fasilitas kampus",
  "Beasiswa",
  "Lokasi kampus",
  "Biaya",
];
const programs = [
    { name: "Ekonomi dan Bisnis", majors: ["Akuntansi", "Manajemen"] },
    { name: "Psikologi", majors: ["Psikolog"] },
    { name: "Ilmu Komputer", majors: ["Manajemen Informatika", "Sistem Informasi", "Sistem Komputer", "Teknik Informatika"] },
    { name: "Keguruan dan Ilmu Pendidikan", majors: ["Pendidikan Teknik Informatika", "Bimbingan Konseling", "Pendidikan Bahasa Inggris"] },
    { name: "Teknik", majors: ["Teknik Sipil", "Teknik Industri"] },
    { name: "Desain Komunikasi Visual", majors: ["Desain Komunikasi Visual (DKV)"] },
  ];
const considerations = [
  "Kualitas pendidikan",
  "Biaya kuliah",
  "Beasiswa",
  "Fasilitas kampus",
  "Lokasi kampus",
  "Peluang karier setelah lulus",
  "Yang lain",
];
const campusImpressions = ["Sangat Menarik", "Menarik", "Cukup Menarik", "Kurang Menarik", "Tidak Menarik"];

const QuisionerOpenHouse = () => {
  const [submitted, setSubmitted] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      school: "",
      grades: "",
      majors: "",
      aware: "",
      informationSource: "",
      interestLevel: "",
      interestReasons: [],
      consideration: "",
      additionalInfo: "",
      enrollmentPlan: "",
      eventFeedback: "",
      campusImpression: "",
      desiredProgram: "",
      selectedMajor: "",
      otherMajor: "",
      otherInformationSource: "",
    },
    validationSchema: Yup.object({
        name: Yup.string().required("Nama lengkap wajib diisi"),
        phone: Yup.string().required("Nomor telepon wajib diisi").matches(/^[0-9]{10,12}$/, "Nomor telepon tidak valid"),
        email: Yup.string().email("Email tidak valid").required("Email wajib diisi"),
        school: Yup.string().required("Sekolah asal wajib dipilih"),
        grades: Yup.string().required("Kelas saat ini wajib dipilih"),
        majors: Yup.string().required("Jurusan di sekolah wajib dipilih"),
        aware: Yup.string().required("Harap pilih apakah Anda tahu tentang UPI YPTK"),
        informationSource: Yup.string().required("Harap pilih sumber informasi tentang UPI YPTK"),
        interestLevel: Yup.number().min(1).max(10).required("Harap pilih tingkat ketertarikan"),
        interestReasons: Yup.array().min(1, "Harap pilih alasan ketertarikan").required("Alasan ketertarikan wajib dipilih"),
        desiredProgram: Yup.string().required("Program studi yang diminati wajib dipilih"),
        selectedMajor: Yup.string().required("Jurusan yang diinginkan wajib dipilih"),
        consideration: Yup.string().required("Harap pilih pertimbangan saat memilih kampus"),
        wantMoreInfo: Yup.string().required("Harap pilih apakah Anda ingin info lebih lanjut"),
        enrollmentPlan: Yup.string().required("Harap pilih rencana pendaftaran"),
        eventFeedback: Yup.number().min(1).max(10).required("Harap beri penilaian untuk event ini"),
        campusImpression: Yup.string().required("Harap beri kesan Anda tentang kampus UPI YPTK"),
    }),
    onSubmit: async (values) => {
      try {
        // Kirim data ke API
        const response = await axios.post(
          "https://app.rlagency.id/apiopenhouse/submit-kuesioner-open-house.php",
          values
        );
  
        if (response.data.success) {
          setSubmitted(true); // Form successfully submitted
        } else {
          alert("Gagal mengirimkan data, silakan coba lagi.");
        }
      } catch (error) {
        console.error("Terjadi kesalahan: ", error);
        alert("Terjadi kesalahan saat mengirimkan data.");
      }
    },
  });
  

  const [isOtherSelected, setIsOtherSelected] = useState(false);

  const handleMajorsChange = (event) => {
    const selectedValue = event.target.value;
    formik.setFieldValue("majors", selectedValue);

    // Toggle the text input if "Yang lain" is selected
    setIsOtherSelected(selectedValue === "Yang lain");

    // Jika bukan "Yang lain", hapus nilai di otherMajor
    if (selectedValue !== "Yang lain") {
      formik.setFieldValue("otherMajor", "");
    }
  };

  const handleOtherMajorChange = (event) => {
    const otherValue = event.target.value;
    formik.setFieldValue("otherMajor", otherValue);

    // Update `majors` dengan nilai dari `otherMajor`
    formik.setFieldValue("majors", otherValue);
  };

  const [isOtherInfoSelected, setIsOtherInfoSelected] = useState(false);

  // Fungsi untuk menangani perubahan dropdown
  const handleInformationSourceChange = (event) => {
    const selectedValue = event.target.value;
    formik.setFieldValue('informationSource', selectedValue);
  
    // Toggle the input field if "Yang lain" is selected
    setIsOtherInfoSelected(selectedValue === 'Yang lain');
  
    // Clear the "otherInformationSource" field if not "Yang lain"
    if (selectedValue !== 'Yang lain') {
      formik.setFieldValue('otherInformationSource', '');
    }
  };
  
  // Fungsi untuk menangani perubahan input teks "Lainnya"
  const handleOtherInformationSourceChange = (event) => {
    const otherValue = event.target.value;
  
    // Set the value of otherInformationSource
    formik.setFieldValue('otherInformationSource', otherValue);
  
    // Update informationSource with the same value as otherInformationSource
    formik.setFieldValue('informationSource', otherValue);
  };

  const [selectedProgram, setSelectedProgram] = useState("");
  const [availableMajors, setAvailableMajors] = useState([]);

  // Update jurusan ketika program studi dipilih
  const handleProgramChange = (event) => {
    const selectedProgram = event.target.value;
    setSelectedProgram(selectedProgram);

    const program = programs.find((program) => program.name === selectedProgram);
    if (program) {
      setAvailableMajors(program.majors);
      formik.setFieldValue("desiredProgram", selectedProgram);
      formik.setFieldValue("selectedMajor", ""); // Reset jurusan
    }
  };


  return (
    <div>
    <div className="container" style={{ padding: "20px", maxWidth: "700px", marginBottom:'50px' }}>
      <div style={{ textAlign:'center', paddingBottom:'10px'}}>
        <img 
            src="./logo-upi-dan-yayasan.png" 
            alt="Deskripsi Gambar" 
            style={{ width: '150px', height: 'auto', marginBottom:'20px' }}
        />
      </div>
      <h1 style={{ textAlign: "start", fontSize:'28px', textTransform:'uppercase' }}>Kuesioner Open House UPI YPTK Padang</h1>
      <p>
        Silakan isi kuesioner berikut untuk memberikan feedback terkait kegiatan Open House di UPI YPTK.
      </p>
      <hr />
      {submitted ? (
        <div>
          <h3 style={{ color: "green" }}>Terima kasih atas partisipasi Anda!</h3>
          <p>Kuesioner Anda telah berhasil dikirim.</p>
        </div>
      ) : (
        <Form onSubmit={formik.handleSubmit}>
            {/* Nama Lengkap */}
            <FormGroup>
                <Label for="name">Nama Lengkap</Label>
                <Input
                id="name"
                name="name"
                type="text"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.name && !!formik.errors.name}
                />
                <FormFeedback>{formik.errors.name}</FormFeedback>
            </FormGroup>

            {/* Nomor Telepon */}
            <FormGroup>
                <Label for="phone">Nomor Telfon yang Terhubung WA</Label>
                <Input
                id="phone"
                name="phone"
                type="text"
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.phone && !!formik.errors.phone}
                />
                <FormFeedback>{formik.errors.phone}</FormFeedback>
            </FormGroup>

            {/* Email */}
            <FormGroup>
                <Label for="email">Email Aktif</Label>
                <Input
                id="email"
                name="email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.email && !!formik.errors.email}
                />
                <FormFeedback>{formik.errors.email}</FormFeedback>
            </FormGroup>

            {/* Sekolah Asal */}
            <FormGroup>
                <Label for="school">Sekolah Asal</Label>
                <Input
                id="school"
                name="school"
                type="select"
                value={formik.values.school}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.school && !!formik.errors.school}
                >
                <option value="">Pilih Sekolah</option>
                {schools.map((school, index) => (
                    <option key={index} value={school}>
                    {school}
                    </option>
                ))}
                </Input>
                <FormFeedback>{formik.errors.school}</FormFeedback>
            </FormGroup>

            {/* Kelas Saat Ini */}
            <FormGroup>
                <Label for="grades">Kelas Saat Ini</Label>
                <Input
                id="grades"
                name="grades"
                type="select"
                value={formik.values.grades}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.grades && !!formik.errors.grades}
                >
                <option value="">Pilih Kelas</option>
                {grades.map((grades, index) => (
                    <option key={index} value={grades}>
                    {grades}
                    </option>
                ))}
                </Input>
                <FormFeedback>{formik.errors.grades}</FormFeedback>
            </FormGroup>

            {/* Jurusan di Sekolah */}
            <FormGroup>
                <Label for="majors">Jurusan di Sekolah</Label>
                <Input
                    id="majors"
                    name="majors"
                    type="select"
                    value={formik.values.majors}
                    onChange={handleMajorsChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.majors && !!formik.errors.majors}
                >
                    <option value="">Pilih Jurusan di Sekolah</option>
                    {majors.map((major, index) => (
                    <option key={index} value={major}>
                        {major}
                    </option>
                    ))}
                </Input>
                <FormFeedback>{formik.errors.majors}</FormFeedback>

                {/* Input Text untuk "Yang lain" */}
                {isOtherSelected && (
                    <FormGroup style={{ marginTop: "10px" }}>
                    <Label for="otherMajor">Isi Jurusan Anda</Label>
                    <Input
                        id="otherMajor"
                        name="otherMajor"
                        type="text"
                        value={formik.values.otherMajor}
                        onChange={handleOtherMajorChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.otherMajor && !!formik.errors.otherMajor}
                    />
                    <FormFeedback>{formik.errors.otherMajor}</FormFeedback>
                    </FormGroup>
                )}
            </FormGroup>

            <div style={{ 
            backgroundColor: 'rgba(255, 255, 0, 0.4)', // Kuning dengan transparansi 40%
            padding: '20px',
            borderRadius: '8px',
            // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Efek bayangan agar lebih menonjol
            margin:'30px 0px'
            }}>
                <h5>Informasi Penting</h5>
                <hr />
                <p>Isi kuisioner dibawah secara objektif. Isian kuisioner tidak akan mempengaruhi nilai/ lainnya.</p>
            </div>

            {/* Mendengar tentang UPI */}
            <FormGroup tag="fieldset">
                <Label>Apakah Anda pernah mendengar tentang UPI YPTK sebelum menghadiri Open House ini?</Label>
                <FormGroup check inline>
                    <Label check>
                    <Input
                        type="radio"
                        name="aware"
                        value="Ya"
                        checked={formik.values.aware === "Ya"}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.aware && !!formik.errors.aware}
                    />
                    Ya
                    </Label>
                </FormGroup>
                <FormGroup check inline>
                    <Label check>
                    <Input
                        type="radio"
                        name="aware"
                        value="Tidak"
                        checked={formik.values.aware === "Tidak"}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.aware && !!formik.errors.aware}
                    />
                    Tidak
                    </Label>
                </FormGroup>
                {formik.touched.aware && formik.errors.aware && (
                    <FormFeedback style={{ display: "block" }}>{formik.errors.aware}</FormFeedback>
                )}
            </FormGroup>

            {/* Bagaimana Anda mengetahui informasi tentang UPI */}
            <FormGroup>
  <Label for="informationSource">Bagaimana Anda mengetahui informasi tentang UPI YPTK?</Label>
  <Input
    id="informationSource"
    name="informationSource"
    type="select"
    value={formik.values.informationSource}
    onChange={handleInformationSourceChange} // Pastikan menangani perubahan di dropdown
    onBlur={formik.handleBlur}
    invalid={formik.touched.informationSource && !!formik.errors.informationSource}
  >
    <option value="">Pilih Sumber Informasi</option>
    {informationSources.map((source, index) => (
      <option key={index} value={source}>
        {source}
      </option>
    ))}
  </Input>
  <FormFeedback>{formik.errors.informationSource}</FormFeedback>

  {/* Input Text untuk "Yang lain" */}
  {isOtherInfoSelected && (
    <FormGroup style={{ marginTop: '10px' }}>
      <Label for="otherInformationSource">Isi Informasi Lainnya</Label>
      <Input
        id="otherInformationSource"
        name="otherInformationSource"
        type="text"
        value={formik.values.otherInformationSource}
        onChange={handleOtherInformationSourceChange} // Menangani perubahan input teks
        onBlur={formik.handleBlur}
        invalid={formik.touched.otherInformationSource && !!formik.errors.otherInformationSource}
      />
      <FormFeedback>{formik.errors.otherInformationSource}</FormFeedback>
    </FormGroup>
  )}
</FormGroup>


            {/* Ketertarikan terhadap upi */}
            <FormGroup>
                <Label for="interestLevel">
                    Seberapa besar ketertarikan Anda untuk melanjutkan studi di UPI YPTK?
                </Label>

                {/* Skala 1 hingga 10 */}
                <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                    <Label check>1 (Tidak Tertarik)</Label>
                    <Input
                    type="range"
                    id="interestLevel"
                    name="interestLevel"
                    min="1"
                    max="10"
                    value={formik.values.interestLevel}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.interestLevel && !!formik.errors.interestLevel}
                    style={{ width: "80%" }}
                    />
                    <Label check>10 (Sangat Tertarik)</Label>
                </div>

                {/* Tampilkan nilai yang dipilih oleh pengguna */}
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <strong>Nilai yang dipilih: {formik.values.interestLevel}</strong>
                </div>

                <FormFeedback>{formik.errors.interestLevel}</FormFeedback>
            </FormGroup>


            <FormGroup>
                <Label for="interestReasons">
                    Apa yang membuat Anda tertarik dengan UPI YPTK? Pilih lebih dari satu jika perlu
                </Label>

                {/* Checkbox untuk alasan */}
                <div>
                    {interests.map((interest, index) => (
                    <div key={index} style={{ marginBottom: "10px" }}>
                        <Input
                        type="checkbox"
                        id={`interestReason${index}`}
                        name="interestReasons"
                        value={interest}
                        checked={formik.values.interestReasons.includes(interest)}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        />
                        <Label for={`interestReason${index}`} style={{ marginLeft: "5px" }}>
                        {interest}
                        </Label>
                    </div>
                    ))}
                </div>

                {/* Checkbox untuk "Yang lain" */}
                <div style={{ marginTop: "10px" }}>
                    <Input
                    type="checkbox"
                    id="otherInterest"
                    name="interestReasons"
                    value="Yang lain"
                    checked={formik.values.interestReasons.includes("Yang lain")}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    />
                    <Label for="otherInterest" style={{ marginLeft: "5px" }}>
                    Yang lain:
                    </Label>

                    {/* Input Text untuk alasan tambahan */}
                    {formik.values.interestReasons.includes("Yang lain") && (
                    <FormGroup style={{ marginTop: "10px" }}>
                        <Input
                        type="text"
                        id="additionalInterest"
                        name="additionalInterest"
                        value={formik.values.additionalInterest || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        />
                    </FormGroup>
                    )}
                </div>

                <FormFeedback>{formik.errors.interestReasons}</FormFeedback>
            </FormGroup>

            
            {/* Program Studi */}
      <FormGroup>
        <Label for="desiredProgram">Program studi apa yang paling Anda minati di UPI YPTK?</Label>
        <Input
          id="desiredProgram"
          name="desiredProgram"
          type="select"
          value={formik.values.desiredProgram}
          onChange={handleProgramChange}
          onBlur={formik.handleBlur}
          invalid={formik.touched.desiredProgram && !!formik.errors.desiredProgram}
        >
          <option value="">Pilih Program Studi</option>
          {programs.map((program, index) => (
            <option key={index} value={program.name}>
              {program.name}
            </option>
          ))}
        </Input>
        <FormFeedback>{formik.errors.desiredProgram}</FormFeedback>
      </FormGroup>

      {/* Jurusan */}
      {selectedProgram && (
        <FormGroup>
          <Label for="selectedMajor">Jurusan</Label>
          <Input
            id="selectedMajor"
            name="selectedMajor"
            type="select"
            value={formik.values.selectedMajor}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={formik.touched.selectedMajor && !!formik.errors.selectedMajor}
          >
            <option value="">Pilih Jurusan</option>
            {availableMajors.map((major, index) => (
              <option key={index} value={major}>
                {major}
              </option>
            ))}
          </Input>
          <FormFeedback>{formik.errors.selectedMajor}</FormFeedback>
        </FormGroup>
      )}


        <FormGroup tag="fieldset">
            <Label>Apa yang paling Anda pertimbangkan saat memilih kampus?</Label>
            {/* Radio Buttons for considerations */}
            {considerations.map((consideration, index) => (
                <FormGroup check key={index}>
                <Label check>
                    <Input
                    type="radio"
                    name="consideration"
                    value={consideration}
                    checked={formik.values.consideration === consideration}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.consideration && !!formik.errors.consideration}
                    />
                    {consideration}
                </Label>
                </FormGroup>
            ))}

            {/* Input Text for "Yang lain" */}
            {formik.values.consideration === "Yang lain" && (
                <FormGroup style={{ marginTop: "10px" }}>
                <Label for="additionalInfo">Isi Pertimbangan Lainnya</Label>
                <Input
                    id="additionalInfo"
                    name="additionalInfo"
                    type="text"
                    value={formik.values.additionalInfo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.additionalInfo && !!formik.errors.additionalInfo}
                />
                <FormFeedback>{formik.errors.additionalInfo}</FormFeedback>
                </FormGroup>
            )}

            <FormFeedback>{formik.errors.consideration}</FormFeedback>
        </FormGroup>

        <FormGroup tag="fieldset">
            <Label>Apakah Anda ingin mendapatkan informasi lebih lanjut tentang UPI YPTK?</Label>
            {/* Radio Buttons for Yes/No */}
            <FormGroup check >
                <Label check>
                <Input
                    type="radio"
                    name="wantMoreInfo"
                    value="Ya"
                    checked={formik.values.wantMoreInfo === "Ya"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.wantMoreInfo && !!formik.errors.wantMoreInfo}
                />
                Ya
                </Label>
            </FormGroup>
            <FormGroup check inline>
                <Label check>
                <Input
                    type="radio"
                    name="wantMoreInfo"
                    value="Tidak"
                    checked={formik.values.wantMoreInfo === "Tidak"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.wantMoreInfo && !!formik.errors.wantMoreInfo}
                />
                Tidak
                </Label>
            </FormGroup>

            <FormFeedback>{formik.errors.wantMoreInfo}</FormFeedback>
        </FormGroup>


        <FormGroup tag="fieldset">
            <Label>Apakah Anda berencana untuk mengikuti program pendaftaran di UPI YPTK?</Label>
            {/* Radio Buttons for the choices */}
            <FormGroup check >
                <Label check>
                <Input
                    type="radio"
                    name="enrollmentPlan"
                    value="Ya, segera"
                    checked={formik.values.enrollmentPlan === "Ya, segera"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.enrollmentPlan && !!formik.errors.enrollmentPlan}
                />
                Ya, segera
                </Label>
            </FormGroup>
            <FormGroup check >
                <Label check>
                <Input
                    type="radio"
                    name="enrollmentPlan"
                    value="Ya, tetapi masih mempertimbangkan"
                    checked={formik.values.enrollmentPlan === "Ya, tetapi masih mempertimbangkan"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.enrollmentPlan && !!formik.errors.enrollmentPlan}
                />
                Ya, tetapi masih mempertimbangkan
                </Label>
            </FormGroup>
            <FormGroup check >
                <Label check>
                <Input
                    type="radio"
                    name="enrollmentPlan"
                    value="Tidak yakin"
                    checked={formik.values.enrollmentPlan === "Tidak yakin"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.enrollmentPlan && !!formik.errors.enrollmentPlan}
                />
                Tidak yakin
                </Label>
            </FormGroup>
            <FormGroup check >
                <Label check>
                <Input
                    type="radio"
                    name="enrollmentPlan"
                    value="Tidak"
                    checked={formik.values.enrollmentPlan === "Tidak"}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.enrollmentPlan && !!formik.errors.enrollmentPlan}
                />
                Tidak
                </Label>
            </FormGroup>

            <FormFeedback>{formik.errors.enrollmentPlan}</FormFeedback>
        </FormGroup>

        
        <FormGroup>
            <Label for="eventFeedback">Bagaimana penilaian Anda terhadap kegiatan Open House ini?</Label>

            {/* Rating Scale from 1 to 10 */}
            <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                <Label check>Kurang Baik</Label>
                <Input
                type="range"
                id="eventFeedback"
                name="eventFeedback"
                min="1"
                max="10"
                value={formik.values.eventFeedback}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.eventFeedback && !!formik.errors.eventFeedback}
                style={{ width: "80%" }}
                />
                <Label check>Sangat Baik</Label>
            </div>

            {/* Display the selected rating value */}
            <div style={{ textAlign: "center", marginTop: "10px" }}>
                <strong>Nilai yang dipilih: {formik.values.eventFeedback}</strong>
            </div>

            <FormFeedback>{formik.errors.eventFeedback}</FormFeedback>
        </FormGroup>


        <FormGroup tag="fieldset">
            <Label>Bagaimana kesan Anda terhadap kampus UPI YPTK setelah mengikuti Open House ini?</Label>

            {/* Radio buttons for the impressions */}
            {campusImpressions.map((impression, index) => (
                <FormGroup check key={index}>
                <Label check>
                    <Input
                    type="radio"
                    name="campusImpression"
                    value={impression}
                    checked={formik.values.campusImpression === impression}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.campusImpression && !!formik.errors.campusImpression}
                    />
                    {impression}
                </Label>
                </FormGroup>
            ))}

            <FormFeedback>{formik.errors.campusImpression}</FormFeedback>
        </FormGroup>


        <Button color="primary" type="submit" >
            {formik.isSubmitting ? 'Mengirim...' : 'Kirim Kuesioner'}
        </Button>

        </Form>
      )}
    </div>
      <Footer />
    </div>
  );
  
};

export default QuisionerOpenHouse;
